import React from "react";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import Switch from "../../Components/Inputs/Switch";
import Images from "./Images";
import DateTimeInput from "../../Components/Inputs/DateTimeInput";
import {BANNER_TYPES} from "../../Constants/Constants";

export default function ({register, control, data, errors, setValue, watch}) {

  const handleTypeChange = type => {
    if (type) {
      const bannerType = BANNER_TYPES?.[type];

      if (!bannerType) return;

      setValue('images', new Array(bannerType.sizes.length).fill({
        desktop_image: '',
        mobile_image: '',
        url: '',
        shop_id: '',
      }));
    }
  }

  return (
    <>
      <ReactSelectInput
        label='Type'
        name='type'
        control={control}
        errorMessage={errors?.type}
        options={data?.bannerTypes}
        inputClassName='mb-5'
        callback={handleTypeChange}
      />

      <DateTimeInput
        label='Start date'
        name='start_date'
        control={control}
        errorMessage={errors?.start_date}
      />

      <DateTimeInput
        label='End date'
        name='end_date'
        control={control}
        errorMessage={errors?.end_date}
      />

      <Switch
        label='Active'
        name='is_active'
        register={register}
        errorMessage={errors?.is_active}
      />

      <Images {...{control, errors, data, register, watch}} />
    </>
  );
}